/* eslint-disable @typescript-eslint/naming-convention */
export const CORE = {
    MENU: {
        PLACEHOLDER: 'Vui lòng chọn một đáp án',
    },
    LOADING: 'Đang xử lý',
    BACK: 'Quay lại',
    RETRY: 'Thử lại',
    CLOSE: 'Đóng',
    ERROR: {
        NOT_FOUND: {
            TITLE: 'Không tìm thấy nội dung',
            MESSAGE:
                'Nội dung này đã theo bống đi xa, nhưng VinID còn nhiều điều để khám phá.',
        },
        UNKNOW_ERROR: {
            TITLE: 'Mọi thứ vẫn ổn trừ trang này',
            MESSAGE:
                'Lâu lắm rồi mới gặp trường hợp như vậy, cùng thử lại sau nhé?',
        },
        NO_INTERNET: {
            TITLE: 'Rớt mạng rồi...',
            MESSAGE:
                'Wifi có đủ vạch? Điện thoại có còn data? Kiểm tra kết nối và thử lại bạn nhé.',
        },
    },
    RESULT: {
        SUCCESS: {
            MESSAGE: 'Cảm ơn bạn đã hoàn thành khảo sát',
            TITLE: 'Gửi thông tin thành công',
        },
        FAIL: {
            TITLE: 'Có lỗi xảy ra, vui lòng thử lại',
            MESSAGE: 'Có lỗi xảy ra, vui lòng thử lại',
        },
    },
    START: {
        TITLE: 'Khảo sát nhu cầu đầu tư tài chính của khách hàng VinID',
        MESSAGE:
            'Tận hưởng vô vàn tiện ích vượt trội cùng với Techcombank, tích lũy điểm thưởng sau mỗi chi tiêu cùng hàng nghìn ưu đãi đặc quyền.',
        BUTTON_START: 'Bắt đầu ngay',
    },
    UPLOAD_FILE: 'Tải file',
    STEPPERS: {
        YOU_HAVE_ANSWER: 'Bạn đã trả lời',
        QUESTION: 'câu hỏi',
        YOU_ARE_IN_PAGE: 'Bạn đang ở trang',
    },
    VALIDATION_MESSAGE: {
        REQUIRED: 'Vui lòng cung cấp thông tin!',
        PATTERN: 'Vui lòng cung cấp thông tin đúng định dạng!',
        LENGTH_ERROR:
            'Vui lòng chọn thông tin đúng số lượng nội dung cho phép!',
    },
    DATE_TIME_PICKER: {
        CANCEL_LABEL: 'Hủy',
        SET_LABEL: 'Đồng ý',
    },
    APPROVE: 'Đồng ý',
    REJECT: 'Từ chối',
    APPROVE_INSTRUCTION: '(*) Vui lòng phê duyệt',
    APPROVE_STATUS: 'Trạng thái phê duyệt:',
    APPROVE_SA_RESULT: '(*) Kết quả Survey của SA',
    APPROVE_CDM_CONTENT: ' Nội dung phê duyệt:',
};
